.about-us-page {
  // 和 Home 一致的容器与断点策略
  --content-max: 1500px;
  --container-pad: clamp(16px, 4vw, 48px);
  --tap-min: 44px;

  .page {
    width: 100%;
    min-height: 100%;
    background-color: rgba(255, 255, 255, 1);
  }

  // ---------------------------------------------------------------------------
  // Hero
  // ---------------------------------------------------------------------------
  .about-hero {
    position: relative;
    width: 100%;
    min-height: clamp(620px, 78vh, 920px);
    background: url(../../assets/images/pages-aboutus-about-hero.png)
      no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }

  .about-hero__overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(10, 10, 10, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .about-hero__content {
    width: min(92vw, var(--content-max));
    padding: 0 var(--container-pad);
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: clamp(16px, 2.2vw, 24px);
  }

  .about-hero__title {
    margin: 0;
    width: min(92vw, 28ch);
    color: rgba(255, 255, 255, 1);
    font-size: clamp(34px, 4vw, 56px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1.05;
    text-transform: none;
  }

  .about-hero__lead {
    margin: 0;
    width: min(92vw, 78ch);
    color: rgba(255, 255, 255, 1);
    font-size: clamp(15px, 1.4vw, 18px);
    font-family: Red Rose-Light;
    font-weight: 300;
    text-align: center;
    line-height: 1.75;
  }

  // ---------------------------------------------------------------------------
  // Certifications
  // ---------------------------------------------------------------------------
  .about-certifications {
    width: 100%;
    padding-bottom: clamp(64px, 10vw, 140px);
  }

  .about-certifications__title {
    margin: clamp(64px, 10vw, 160px) auto 0;
    padding-inline: var(--container-pad);
    box-sizing: border-box;
    max-width: var(--content-max);
    text-transform: uppercase;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(40px, 6vw, 80px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1;
  }

  .certification {
    width: 100%;
    margin: clamp(40px, 6vw, 120px) 0 0;
    display: grid;
    grid-template-columns: 1.4fr 1fr;
    min-height: clamp(420px, 48vw, 600px);
  }

  .certification__body {
    background-color: rgba(196, 180, 157, 1);
    padding: clamp(28px, 4vw, 56px) var(--container-pad);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: clamp(16px, 2.2vw, 24px);
  }

  .certification__heading {
    margin: 0;
    color: rgba(255, 255, 255, 1);
    font-size: clamp(26px, 3.2vw, 48px);
    font-family: Red Rose-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 1.1;
    max-width: 28ch;
  }

  .certification__text {
    margin: 0;
    color: rgba(255, 255, 255, 1);
    font-size: clamp(14px, 1.2vw, 18px);
    font-family: PingFang SC-Regular;
    font-weight: normal;
    text-align: left;
    line-height: 1.8;
    max-width: 78ch;
  }

  .certification__media {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    min-height: 280px;
  }

  .certification__media--lacey {
    background-image: url(../../assets/images/pages-aboutus-certification-media-lacey.png);
  }

  .certification__media--carb {
    background-image: url(../../assets/images/pages-aboutus-certification-media-carb.png);
  }

  .certification__media--section01350 {
    background-image: url(../../assets/images/pages-aboutus-certification-media-section01350.png);
  }

  .certification__badge {
    position: absolute;
    width: clamp(88px, 10vw, 160px);
    height: clamp(88px, 10vw, 160px);
    object-fit: contain;
    filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.18));
  }

  .certification__badge--lacey,
  .certification__badge--section01350 {
    right: clamp(16px, 2.5vw, 48px);
    bottom: clamp(16px, 2.5vw, 48px);
  }

  .certification__badge--carb {
    left: clamp(16px, 2.5vw, 48px);
    bottom: clamp(16px, 2.5vw, 48px);
  }

  .certification--reversed {
    grid-template-columns: 1fr 1.4fr;

    .certification__body {
      order: 2;
      background-color: rgba(255, 255, 255, 1);
    }

    .certification__heading,
    .certification__text {
      color: rgba(22, 0, 4, 1);
    }
  }

  // ---------------------------------------------------------------------------
  // Support
  // ---------------------------------------------------------------------------
  .about-support {
    width: 100%;
    max-width: var(--content-max);
    margin: clamp(64px, 10vw, 180px) auto 0;
    padding-inline: var(--container-pad);
    box-sizing: border-box;
    text-align: center;
  }

  .about-support__title {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(40px, 6vw, 80px);
    font-family: Red Rose-Medium;
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
    line-height: 1;
    white-space: normal;
  }

  .about-support__text {
    margin: clamp(16px, 3.5vw, 40px) auto 0;
    max-width: min(72ch, 100%);
    color: rgba(124, 124, 124, 1);
    font-size: clamp(16px, 1.6vw, 24px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    text-align: center;
    line-height: 1.6;
  }

  // ---------------------------------------------------------------------------
  // Breakpoints
  // ---------------------------------------------------------------------------
  @media (max-width: 1023px) {
    .about-hero {
      min-height: clamp(580px, 74vh, 760px);
    }

    .certification {
      grid-template-columns: 1fr;
      min-height: unset;
    }

    .certification--reversed {
      grid-template-columns: 1fr;

      .certification__body {
        order: 0;
      }
    }

    .certification__media {
      min-height: clamp(260px, 56vw, 420px);
    }
  }

  @media (max-width: 767px) {
    .about-hero {
      min-height: clamp(540px, 70vh, 680px);
    }

    .certification__body {
      padding: clamp(22px, 5vw, 32px) var(--container-pad);
    }
  }
}

